import React from 'react';

function Menu(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size ? (props.size * 12) / 19 : undefined} viewBox="0 0 19 12">
            <g fill="none" fillRule="evenodd" stroke={props.color} strokeLinecap="round" strokeWidth="2">
                <path d="M17.5 1h-16M17.5 6h-16M17.5 11h-16" />
            </g>
        </svg>
    );
}

export default Menu;
